import React from 'react';
import wb0 from '../img/Detail/scops_detail.jpg';
import './Detail.css';
const ScopsFunDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default ScopsFunDetail;